module.exports = __webpack_public_path__ + "img/jp-del.c740fc11.png";